<template>
  <a-config-provider>
    <template #renderEmpty>
      <a-empty description="Brak aplikacji" />
    </template>
    <a-list
      class="list c-list"
      :loading="loading"
      itemLayout="horizontal"
      :pagination="pagination"
      :dataSource="results"
    >
      <list-cols-header
        slot="header"
        :headers="headers"
        :actions-cols="readOnly ? 0 : 2"
        :col-spans="[8, 16]"
      />

      <a-list-item
        slot="renderItem"
        slot-scope="item"
        :class="{ 'list-item--with-info-box': showInfoBox(item) }"
        class="list-item"
      >
        <a-row type="flex" class="item-row" :gutter="24">
          <a-col span="8">
            <a-list-item-meta>
              <span slot="title">
                {{ item.name }}
              </span>
            </a-list-item-meta>
          </a-col>

          <a-col span="16">
            <a-list-item-meta>
              <a
                slot="title"
                :href="item.url"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ item.url }}
              </a>
            </a-list-item-meta>
          </a-col>
        </a-row>

        <a slot="actions" v-if="!readOnly">
          <a-button type="link" icon="edit" @click="editInstance(item.id)" />
        </a>
        <a slot="actions" v-if="!readOnly">
          <a-button
            type="link"
            icon="delete"
            class="c-remove-button"
            @click="deleteInstance(item.id)"
          />
        </a>

        <div class="info-box" v-if="showInfoBox(item)">
          Login oraz hasło zostały wysłane na Twoją skrzynkę mailową!
        </div>
      </a-list-item>
    </a-list>
  </a-config-provider>
</template>

<script>
export default {
  props: {
    results: Array,
    pagination: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        {
          title: 'Nazwa'
        },
        {
          title: 'Link'
        }
      ]
    }
  },
  computed: {
    showInfoBox() {
      return item => item.login && (this.isStudent || this.isLecturer)
    }
  },
  methods: {
    editInstance(instanceId) {
      this.$emit('editInstance', { instanceId })
    },
    deleteInstance(instanceId) {
      this.$emit('deleteInstance', instanceId)
    }
  }
}
</script>

<style lang="scss" scoped>
.item-row {
  flex: 1;
  width: 100%;

  ::v-deep .ant-list-item-meta-title a {
    color: inherit;
  }
}

.list-item {
  position: relative;

  &--with-info-box {
    padding-bottom: 56px;
  }
}

.info-box {
  position: absolute;
  bottom: 16px;
  font-size: 11px;
  padding: 4px 12px;
  left: 24px;

  background: rgba(black, 0.04);
  border-radius: 8px;
}
</style>
